import Button from 'tailwind-components/Button/Button';
import React from 'react';
import propTypes from 'prop-types';
import { Pencil } from 'lucide-react';
import { cn } from 'lib/utils';

function FormWithEditButton({
  children,
  className,
  onClick,
  buttonText,
  inverted = false,
  fill = true,
  alignButton = 'end',
  showButton = true
}) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 h-full grow flex-1',
        inverted && 'flex-col-reverse justify-end',
        !inverted && 'justify-between',
        className
      )}
    >
      {children}
      {showButton && (
        <Button
          className={cn(
            'self-end',
            alignButton === 'end' && 'self-end',
            alignButton === 'start' && 'self-start',
            alignButton === 'center' && 'self-center',
            alignButton === 'between' && 'self-between',
            alignButton === 'around' && 'self-around'
          )}
          size='small'
          variant='primary'
          fill={fill}
          text={buttonText}
          onClick={onClick}
          icon={<Pencil size={20} />}
        />
      )}
    </div>
  );
}

FormWithEditButton.propTypes = {
  inverted: propTypes.bool,
  children: propTypes.node,
  onClick: propTypes.func,
  className: propTypes.string,
  buttonText: propTypes.string,
  fill: propTypes.bool,
  alignButton: propTypes.oneOf(['end', 'start', 'center', 'between', 'around']),
  showButton: propTypes.bool
};

export default FormWithEditButton;
